import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CommunicationFundamentalsLanguageProbabilisticNLP = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Communication-Fundamentals of Language -Probabilistic Language Processing"
    videos={[
      "https://www.youtube.com/embed/bPpwZxasJo0"
    ]}
    takeaways={[]}
    questions={[
      "Develop an NLP model to create a calendar entry from email received. Explain the approach that you would select to perform the task with a suitable example."
    ]}
    exampleVideos={[]}
  />
);
}

export default CommunicationFundamentalsLanguageProbabilisticNLP;
